import ExistingMandateBankDetailsModal from './ExistingMandateModal/ExistingMandateBankDetailsModal';

import {UK_COUNTRY_CODE} from '../../../../utils/constant';

import {Button, Card, CardContent} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import './ExistingMandate.css';

const ExistingMandate = (props) => {
  const {t} = useTranslation();
  const [visible, setVisible] = React.useState(false);
  const [visibleDDMandate, setVisibleDDMandate] = React.useState(false);
  const [existingMandateData, setExistingMandateData] = React.useState([]);
  const [ddMandateData, setDDMandateData] = React.useState([]);

  const transformData = () => {
    if (props.contractDetails) {
      const resultMap = new Map();
      for (const [contractNumber, details] of Object.entries(
        props.contractDetails
      )) {
        const {accountNumber, bankAccount} = details.autoPayAuthorization;
        let account =
          props.country === UK_COUNTRY_CODE ? accountNumber : bankAccount.iban;
        if (!resultMap.has(account)) {
          resultMap.set(account, {
            account,
            bankAccount,
            contractNumber: [],
          });
        }
        resultMap.get(account).contractNumber.push(Number(contractNumber));
      }
      let allData = Array.from(resultMap.values());
      if (props.contractNumber === 'ALL_CONTRACTS') {
        return allData;
      } else {
        return allData.filter((mand) =>
          mand.contractNumber.includes(+props.contractNumber)
        );
      }
    }
  };

  const getMandateText = (array) => {
    const length = array.length;
    if (length === 1) {
      return props.country === UK_COUNTRY_CODE ? `5U${array[0]}` : array[0];
    } else {
      const remainingCount = length > 2 ? length - 2 : 0;
      let output = array
        .slice(0, 2)
        .map((num) => (props.country === UK_COUNTRY_CODE ? `5U${num}` : num))
        .join(', ');

      if (remainingCount > 0) {
        output += ` +${remainingCount}`;
      }

      return output;
    }
  };

  React.useEffect(() => {
    const data = transformData();
    let item, tempDate;
    tempDate = data?.map((mandate) => {
      item = {
        ACC_HOLDER_NAME: {
          label: t('EXISTING_ACC_HOLDER_NAME'),
          value: mandate.bankAccount.accountHolderName ?? 'NA',
        },
        ACC_NUMBER: {
          label: t('EXISTING_BANK_ACC'),
          value: mandate.account ?? 'NA',
        },
        REFERENCE_NUMBER: {
          label: t('REFERENCE_NUMBER'),
          value: getMandateText(mandate.contractNumber),
          tooltip: mandate.contractNumber
            .map((num) =>
              props.country === UK_COUNTRY_CODE ? `5U${num}` : num
            )
            .join('\n'),
        },
      };
      return item;
    });
    setExistingMandateData(tempDate);
    let ddMndateDate = [
      {
        CREDITOR_ID: {
          label: t('CREDITOR_ID'),
          value: t('CREDITOR_ID_VALUE'),
        },
        CREDITOR_NAME: {
          label: t('CREDITOR_NAME'),
          value: t('CREDITOR_NAME_VALUE'),
        },
        ADDRESS: {
          label: t('ADDRESS'),
          value: t('ADDRESS_VALUE'),
        },
      },
    ];
    setDDMandateData(ddMndateDate);
  }, [props.contractNumber, props.contractDetails]);

  return (
    <div className={'ExistingMandateWrapper'}>
      <Card className="cardCustom">
        <CardContent className="ExistingMandateCard">
          <div className={'existingMandateHeaderTop'}>
            <div className={'existingMandateHeader'}>
              <div className={'existingMandateTitle'}>
                {t('CURRENT_BANK_ACCOUNT')}
              </div>
              <div className={'existingMandateSubTitle'}>
                {t('CURRENT_BANK_ACCOUNT_SUBTEXT')}
              </div>
            </div>
            <Button
              id="viewExistingMandate"
              variant="text"
              onClick={() => setVisible(!visible)}
            >
              {t('VIEW')}
            </Button>
          </div>
        </CardContent>
      </Card>
      <Card className="cardCustom">
        <CardContent className="ExistingMandateCard">
          <div className={'existingMandateHeaderTop'}>
            <div className={'existingMandateHeader'}>
              <div className={'existingMandateTitle'}>{t('DD_MANDATE')}</div>
              <div className={'existingMandateSubTitle'}>
                {t('DD_MANDATE_SUBTEXT')}
              </div>
            </div>
            <Button
              id="viewExistingMandate"
              variant="text"
              onClick={() => setVisibleDDMandate(!visibleDDMandate)}
            >
              {t('VIEW')}
            </Button>
          </div>
        </CardContent>
      </Card>
      <ExistingMandateBankDetailsModal
        id="ExistingMandateBankDetailsPopupModal"
        title={t('CURRENT_BANK_ACCOUNT_POPUP')}
        visible={visible}
        setVisible={setVisible}
        mandateData={existingMandateData}
      />
      <ExistingMandateBankDetailsModal
        id="ExistingMandateBankDetailsDDPopupModal"
        title={t('DD_MANDATE_POPUP')}
        visible={visibleDDMandate}
        setVisible={setVisibleDDMandate}
        mandateData={ddMandateData}
      />
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    country: state.appStates.allContracts?.countryCode,
    contractDetails: state.appStates.contractDetails?.accountDetails,
    selectedOrg: state.appStates.selectedOrg,
    userDetails: state.appStates.userDetailsInfo,
  };
};

export default connect(mapStateToProps)(ExistingMandate);
